import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class AppConfigService {
  get university(): string {
    return (globalThis as any).__env?.university;
  }

  get showConsoleLogs(): boolean {
    const showConsoleLogs = (globalThis as any).__env?.showConsoleLogs;

    if (typeof showConsoleLogs === "string") {
      return showConsoleLogs.toLowerCase() === "true";
    }

    return Boolean(showConsoleLogs);
  }

  get assetBaseUrl(): string {
    return (globalThis as any).__env?.assetBaseUrl;
  }

  get blobBaseBackendUrl(): string {
    return (globalThis as any).__env?.blobBaseBackendUrl;
  }

  get fileUploadWebSocketApiUrl(): string {
    return (globalThis as any).__env?.commonConfig.fileUploadWebSocketApiUrl;
  }

  get dataEditWebSocketApiUrl(): string {
    return (globalThis as any).__env?.commonConfig.dataEditWebSocketApiUrl;
  }

  get courseMAtchingApiUrl(): string {
    return (globalThis as any).__env?.commonConfig.courseMAtchingApiUrl;
  }

  get feedbackApiUrl(): string {
    return (globalThis as any).__env?.feedback.feedbackApiUrl;
  }

  get oktaAuthService(): string {
    return (globalThis as any).__env?.oktaAuthService;
  }

  get clientId(): string {
    return (globalThis as any).__env?.clientId;
  }

  get issuer(): string {
    return (globalThis as any).__env?.issuer;
  }

  get redirectUri(): string {
    return (globalThis as any).__env?.redirectUri;
  }

  get oktaSignoutRedirectUri(): string {
    return (globalThis as any).__env?.oktaSignoutRedirectUri;
  }

  get mmpUploadApiUrl(): string {
    return (globalThis as any).__env?.mmpConfig?.filesUploadApiUrl;
  }

  get mmpExtractionWebsocketUrl(): string {
    return (globalThis as any).__env?.mmpConfig?.extractionWebsocketUrl;
  }

  get mmpEvaluationWebsocketUrl(): string {
    return (globalThis as any).__env?.mmpConfig?.evaluationWebsocketUrl;
  }

  get mmpEquivalencyWebsocketUrl(): string {
    return (globalThis as any).__env?.mmpConfig?.equivalencyWebsocketUrl;
  }

  get mmpGraphClosingWebsocketUrl(): string {
    return (globalThis as any).__env?.mmpConfig?.graphClosingWebsocketUrl;
  }

  get mmpPreEvaluationReportUrl(): string {
    return (globalThis as any).__env?.mmpConfig?.preEvaluationReportUrl;
  }

  get mmpFinalFeedbackApiUrl(): string {
    return (globalThis as any).__env?.mmpConfig?.finalFeedbackApiUrl;
  }

  get mmpCourseSearchApiUrl(): string {
    return (globalThis as any).__env?.mmpConfig?.courseSearchApiUrl;
  }

  get mmpWebsocketRetryUrl(): string {
    return (globalThis as any).__env?.mmpConfig?.websocketRetryUrl;
  }

  get mmpCurrentUserDetailsUrl(): string {
    return (globalThis as any).__env?.mmpConfig?.currentUserDetails;
  }

  get mmpDashboardDetailsUrl(): string {
    return (globalThis as any).__env?.mmpConfig?.dashboardDetailsUrl;
  }

  get mmpProspectDetailsUrl(): string {
    return (globalThis as any).__env?.mmpConfig?.prospectsDetailsUrl;
  }

  get mmpFilterDataUrl(): string {
    return (globalThis as any).__env?.mmpConfig?.filterDataApiUrl;
  }

  get apiBaseUrl(): string {
    return (globalThis as any).__env?.apiBaseUrl;
  }

  get mmpMetadataWebsocketUrl(): string {
    return (globalThis as any).__env?.mmpConfig?.metadataWebsocketUrl;
  }
}
